import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Header, FieldName, FieldValue } from '../_local/styles'
import Pencil from '@material-ui/icons/Edit'
import WorkPreferencesDialog from '../_local/modals/WorkPreferencesDialog'
import { getWorkPreferenceFields } from '../service'
import { Box, Button } from '@material-ui/core'

const WorkPreferencesRow = (props) => {
  const { workPreference, id, legacyFreelancerId, paroIncomeStatus, hasCurrentClients, setPropChange } = props
  const [open, setOpen] = useState(false)
  const isOpenToOnsite: boolean = workPreference?.isOpenToOnsite  || false

  const initialValues = {
    id: workPreference ? workPreference.id : undefined,
    expertId: id,
    legacyFreelancerId,
    contactStylePreference:  workPreference?.contactStylePreference || '',
    contactTimePreference:  workPreference?.contactTimePreference  || '',
    paroIncomeStatus:  paroIncomeStatus  || '',
    hasCurrentClients: typeof hasCurrentClients === 'boolean' ? hasCurrentClients  : '',
    isOpenToOnsite:  isOpenToOnsite.toString(),
    intendedMonthlyIncome:  workPreference?.intendedMonthlyIncome  || '',
    projectType:  workPreference?.projectType  || '',
    weeklyWorkloadHours:  workPreference?.weeklyWorkloadHours  || '',
    totalFreelanceExperience:  workPreference?.totalFreelanceExperience  || '',
  }
  
  const sortedFields = {
    contactStylePreference: initialValues.contactStylePreference,
    contactTimePreference: initialValues.contactTimePreference,
    paroIncomeStatus: initialValues.paroIncomeStatus,
    hasCurrentClients: initialValues.hasCurrentClients ? 'Yes' : 'No',
    isOpenToOnsite: initialValues.isOpenToOnsite === 'true' ? 'Yes' : 'No',
    intendedMonthlyIncome: initialValues.intendedMonthlyIncome,
    projectType: initialValues.projectType,
    weeklyWorkloadHours: initialValues.weeklyWorkloadHours,
    totalFreelanceExperience: initialValues.totalFreelanceExperience,
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Header>Work Preference</Header>
        </Grid>

        <Grid item>
          <Button onClick={handleClickOpen} startIcon={<Pencil />} color="primary">
            Edit
          </Button>
        </Grid>
      </Grid>

      <Box style={{ width: '75%' }}>
        <Grid container spacing={5}>
          {Object.entries(sortedFields).map((field, index) => {
            const formattedFields = getWorkPreferenceFields(field)
            return (
              <Grid item key={index}>
                <FieldName>{formattedFields?.label}</FieldName>
                <FieldValue>{formattedFields?.value}</FieldValue>
              </Grid>
            )
          })}
        </Grid>
      </Box>
      <WorkPreferencesDialog
        open={open}
        handleClose={handleClose}
        initialValues={initialValues}
        setPropChange={setPropChange}
      />
    </>
  )
}

export default WorkPreferencesRow
